module.exports = __webpack_public_path__ + "static/media/manekin_logo.db3c7624.png";